export default __webpack_public_path__ + "static/media/partner6.bd54412c.png";